import { mira_russ_01_puppies } from "./mira_russ_01_puppies";
import { mira_boz_01_puppies } from "./mira_boz_01_puppies";
import { bowie_charlie_01_puppies } from "./bowie_charlie_01_puppies";
import { bowie_goose_01_puppies } from "./bowie_goose_01_puppies";

export const litters_Previous = [
    {title:"Bowie and Goose", url:"litters/previous/bowie_goose_2025", submenu:bowie_goose_01_puppies},
    {title:"Bowie and Charlie", url:"litters/previous/bowie_charlie_2023", submenu:bowie_charlie_01_puppies},
    {title:"Mira and Boz", url:"litters/previous/mira_boz_2023", submenu:mira_boz_01_puppies},
        {title:"Mira and Russ", url:"litters/previous/mira_russ_2022",submenu:mira_russ_01_puppies},
    ];